import { Component } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { environment } from '@env';

@Component({
  selector: 'app-ada-access',
  templateUrl: './ada-access.component.html',
  styleUrls: ['./ada-access.component.scss']
})
export class AdaAccessComponent {

  constructor(private keycloakService: KeycloakService, private router: Router) { }

  user = '';
  isLoggedIn = false;
  async ngOnInit() {
    const userInfo = await this.keycloakService.loadUserProfile();
    this.user = userInfo?.username || null;
    this.isLoggedIn = await this.keycloakService.isLoggedIn();
  }

  async loginOrLogout() {
    if (this.isLoggedIn) {
      await this.keycloakService.logout();

    } else {
      await this.keycloakService.login({
        redirectUri:  environment.keyCloakRedirectUrl,
      });

    }
  }

  asset() {
    this.router.navigate(['ada-access/asset/search']);
  }
  accessflow() {
    this.router.navigate(['ada-access/access-flow/search']);
  }
  logout(): void {
    this.keycloakService.logout( environment.keyCloakRedirectUrl);
  }
  back() {
    this.router.navigate(['products']);
  }

  openTools(){
    this.router.navigate(['ada-access/auth-tools']);
  }

  navigateToHome() {
    this.router.navigate(['/']).then(() => {
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500); // Delay to ensure page loads before scrolling
    });
  }
}
